export const myConstants = {
    // Der Standard-Dashboard
    dashboard : 0,

    // Kennzeichen, dass dieser Parameter nicht geändert werden soll
    doNotChange: -1,

    // Kennung für die Gesamtsumme in einer Übersicht
    totalId: 99,

    // Nachrichtentypen
    msg_failure: "failure",
    msg_success: "success",
    msg_warning: "warning",

    // die unterschiedlichen Besuchstypen
    saturday : "saturday",
    weekend: "weekend",
    overnight: "overnight",

    // Anreisetag
    fd_friday:"friday",
    fd_saturday: "saturday", 
    
    // BaseURL - hier unterscheiden React anhand
    // der Art und Weise, wie gestartet wurde:
    // npm start: 'development'
    // npm run build: 'production'
    baseURL : 
      process.env.NODE_ENV === "production"
      ? '/'
      : "http://localhost:8000",

    // EndPoints
    endpoints: 
    {
      user:
      {
        login:    'user/login/',
        profile:  'user/profile/',
      },
      api:
      {
        base: 'api/',
        tournaments:  'api/tournament/',
        invoice: 'invoice/',
        clubs: '/clubs/',
        // Einzelaktionen
        club: '/club/',
        teams: '/teams/',
        users: '/users/',
        user: '/user/',        
        admin: '/admin/',
        tournament: '/tournament/',
        registration: 'status/',        
      },
      actions:
      {
        clubs: 
        {
          list        : 'addlist',
          unregistered: 'unregistered/',
        },
        
        club: 
        {
          add: 'club/add/',
          get: 'club/',
          update: 'club/',          
          logo: 
          {
            get: 'logo/',
            add: '/logo/add/',
          },
        },

        user:
        {
          emailValidity: 'email-validity/',
        },

        roles:
        {
          add   : 'add/',
          update: 'update/',
          remove: '/delete/',
        },

        team: 
        {
          add: 'add/',
          pay: 'pay/',
          update: 'update/',
          remove: 'delete/',
          status: 'status/',
        },

        tournament: 
        {
          copy: 'copy/', 
          update: 'update/',
        }
      },

    },

    // Lokale Verknüpfung
    clubModel:
    {
      status:
      {
        registered: "registered",
        interested: "interested",
        cancelled:  "cancelled", 
      },
    },


    teamModel:
    {
      status:
      {
        registered: 'registered',
        waitlist:   'waitlist',
        withdrawn:  'cancelled',
      },
    },
    
};